export const listVendorCategories = {
  page: "listAllVendorCategoriesPage",
  limit: "listAllVendorCategoriesLimit",
  search: "listAllVendorCategoriesSearch",
};
export const listAgeGroups = {
  page: "listAllAgeGroupsPage",
  limit: "listAllAgeGroupsLimit",
  search: "listAllAgeGroupsSearch",
};
export const listClassesSubjects = {
  page: "listAllClassesSubjectsPage",
  limit: "listAllClassesSubjectsLimit",
  search: "listAllClassesSubjectsSearch",
};
export const listAcademicYears = {
  page: "listAllAcademicYearsPage",
  limit: "listAllAcademicYearsLimit",
  search: "listAllAcademicYearsSearch",
};
export const listSchools = {
  page: "listAllSchoolsPage",
  limit: "listAllSchoolsLimit",
  search: "listAllSchoolsSearch",
  filterByClass: "filterByClassInSchool",
  scrollPosition: "listAllSchoolsScrollPosition",
};
export const listActivityConfigurations = {
  search: "listAllActivityConfigurationsSearch",
};
export const listTeachers = {
  page: "listAllTeachersPage",
  limit: "listAllTeachersLimit",
  search: "listAllTeachersSearch",
  filterBySchool: "filterBySchoolInTeacher",
  filterByClass: "filterByClassInTeacher",
  filterBySubject: "filterBySubjectInTeacher",
  scrollPosition: "listAllTeachersScrollPosition",
};
export const listStudents = {
  page: "listAllStudentsPage",
  limit: "listAllStudentsLimit",
  search: "listAllStudentsSearch",
  filterBySchool: "filterBySchoolInStudents",
  filterByClass: "filterByClassInStudents",
  filterBySubject: "filterBySubjectInStudents",
  scrollPosition: "listAllStudentsScrollPosition",
};
export const listVendors = {
  page: "listAllVendorsPage",
  limit: "listAllVendorsLimit",
  search: "listAllVendorsSearch",
  filterByCategory: "filterByCategoryInVendors",
  filterBySubCategory: "filterBySubCategoryInVendors",
  scrollPosition: "listAllVendorsScrollPosition",
};